import { render, staticRenderFns } from "./upload-test.vue?vue&type=template&id=12d273ed&scoped=true&"
import script from "./upload-test.js?vue&type=script&lang=js&"
export * from "./upload-test.js?vue&type=script&lang=js&"
import style0 from "./upload-test.scss?vue&type=style&index=0&id=12d273ed&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d273ed",
  null
  
)

export default component.exports